import { useState } from 'react'

import { faSmile } from '@fortawesome/pro-light-svg-icons/faSmile'
import Icon from '@space-lib/components/icon'

import { EmojiUtils } from '@space-lib/utils/emoji'
import clsx from 'clsx'

import { CustomButton } from './styles'
import type { EmojiSelectProps } from './types'

import { Emoji } from '../emoji'
import EmojiPicker from '../emojiPicker'
import type { EmojiData } from '../emojiPicker/types'

const EmojiSelect = ({ label, labelClassName = '', onChange, value, name }: EmojiSelectProps) => {
  const [showEmojiBox, setShowEmojiBox] = useState(false)

  const handleSelectEmoji = (emojiData: EmojiData) => {
    onChange(EmojiUtils.convertUnifiedToNative(emojiData.unified))
    setShowEmojiBox(false)
  }

  return (
    <div className='_mr-2'>
      {label && <p className={clsx('_mb-2', labelClassName)}>{label}</p>}
      <CustomButton
        className='hot-button _d-flex _align-items-center _justify-content-center _px-4'
        onClick={() => setShowEmojiBox(!showEmojiBox)}>
        {value ? <Emoji id={value} /> : <Icon icon={faSmile} />}
      </CustomButton>
      <EmojiPicker
        close={() => setShowEmojiBox(false)}
        isOpen={showEmojiBox}
        handleSelectEmoji={handleSelectEmoji}
        name={name}
      />
    </div>
  )
}

export default EmojiSelect
